export function About() {
  return `
    <section id="tentang" class="section bg-dark">
      <div class="container">

        <div class="row align-items-center">

          <!-- Text -->
          <div class="col-md-6" data-aos="fade-right">
            <h2 class="mb-3">Tentang Kami</h2>

            <p class="text-secondary">
              <strong>Hunter Cuan</strong> adalah penyedia layanan digital kreatif yang fokus membantu 
              UMKM, individu, dan instansi dalam memenuhi kebutuhan digital mereka.
            </p>

            <p class="text-secondary">
              Kami menyediakan berbagai layanan mulai dari percetakan, pembuatan website, 
              undangan digital, hingga instalasi sistem ujian berbasis CBT.
            </p>

            <p class="text-secondary">
              Dengan pendekatan yang fleksibel dan harga terjangkau, kami siap membantu Anda 
              mendapatkan solusi terbaik sesuai kebutuhan.
            </p>
          </div>

          <!-- Highlight Box -->
          <div class="col-md-6 mt-4 mt-md-0" data-aos="fade-left">
            <div class="about-box p-4">

              <h5 class="mb-3">Kenapa Hunter Cuan?</h5>

              <ul class="list-unstyled text-secondary">
                <li class="mb-2">✔ Layanan lengkap dalam satu tempat</li>
                <li class="mb-2">✔ Harga terjangkau & fleksibel</li>
                <li class="mb-2">✔ Proses cepat & responsif</li>
                <li class="mb-2">✔ Bisa konsultasi sebelum order</li>
              </ul>

            </div>
          </div>

        </div>

      </div>
    </section>
  `;
}
